import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App as AntdApp, ConfigProvider } from "antd";
import { ApolloProvider } from "@apollo/client";

import client from "graphql/client";

import App from "components/app";
import Auth from "components/auth";
import { AppFeedback } from "components/request-result";

import customizeTheme from "components/customize-theme";

import { cssVariable } from "graphql/cache";
import { getCSSVariables } from "common/utils";

import "antd/dist/reset.css";
import "scss/default.scss";



const cssVar: Record<string, string> = getCSSVariables();

const RootComponent: React.FC = () =>
{
    cssVariable(cssVar);

    return (
        <ConfigProvider theme={customizeTheme.DarkTheme()}>
            <AntdApp>
                <AppFeedback />
                <ApolloProvider client={client}>
                    <BrowserRouter>
                        <Auth public={<App.Public />} private={<App.Private />} />
                    </BrowserRouter>
                </ApolloProvider>
            </AntdApp>
        </ConfigProvider>
    );
};

const rootElement = document.getElementById("root");
const root = createRoot(rootElement as HTMLElement);

root.render(<RootComponent />);
